module.exports = __webpack_public_path__ + "static/media/logo_ICMA.7bfdd3c6.jpg";